import React from "react";
import { iconStyles } from "./iconStyles";
export function MenuIcon() {
    return (<svg className={iconStyles} viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 10C6 9.1875 6.625 8.5 7.5 8.5H32.5C33.3125 8.5 34 9.1875 34 10C34 10.875 33.3125 11.5 32.5 11.5H7.5C6.625 11.5 6 10.875 6 10ZM6 20C6 19.1875 6.625 18.5 7.5 18.5H32.5C33.3125 18.5 34 19.1875 34 20C34 20.875 33.3125 21.5 32.5 21.5H7.5C6.625 21.5 6 20.875 6 20ZM34 30C34 30.875 33.3125 31.5 32.5 31.5H7.5C6.625 31.5 6 30.875 6 30C6 29.1875 6.625 28.5 7.5 28.5H32.5C33.3125 28.5 34 29.1875 34 30Z"/>
        </svg>);
}
